import { createContext, useState } from "react";

const AdvancedExchangeContext = createContext({
  shopifyStorefrontCart: null,
  setShopifyStorefrontCart: (shopifyStorefrontCart: any) => {},
  // All the products in which the products were selected for an advanced exchange
  cartMenuOpen: false,
  setCartMenuOpen: (cartMenuOpen: boolean) => {},
  cartVisible: false,
  setCartVisible: (cartVisible: boolean) => {},
});

const AdvancedExchangeContextProvider = ({ children }) => {
  const [shopifyStorefrontCart, setShopifyStorefrontCart] = useState(null);
  const [cartMenuOpen, setCartMenuOpen] = useState(false);
  const [cartVisible, setCartVisible] = useState(false);

  return (
    <AdvancedExchangeContext.Provider
      value={{
        shopifyStorefrontCart,
        setShopifyStorefrontCart,
        cartMenuOpen,
        setCartMenuOpen,
        cartVisible,
        setCartVisible,
      }}
    >
      {children}
    </AdvancedExchangeContext.Provider>
  );
};

export { AdvancedExchangeContext, AdvancedExchangeContextProvider };
